export const defaultOptions = {
  diameterRatio: 0.4,
  marginRatio: 0.2,
  appendPadding: [20, 0, 0, 0],
  tooltip: {
    shared: true,
    showMarkers: false,
    offset: 20,
  },
  interactions: [{ type: 'element-active' }],
};
